<div class="pe-root">
  <div class="mb-3 position-relative">

    <!-- Contenedor real de Stripe Elements: siempre presente -->
    <div
      class="pe-container"
      [id]="containerId"
      [attr.aria-busy]="!isReady"
      [style.display]="isReady ? 'block' : 'none'">
    </div>

    <!-- Skeleton encima mientras no esté listo -->
    <ng-container *ngIf="!isReady && showSkeleton">
      <div class="card pe-skeleton" aria-hidden="true">
        <div class="card-body d-flex flex-column gap-3">
          <h5 class="card-title placeholder-wave">
            <span class="placeholder col-7"></span>
          </h5>
          <p class="card-text placeholder-glow align-items-center">
            <span class="placeholder rounded-circle mb-3" style="width: 20px; height: 20px;"></span>
            <span class="placeholder col-11 float-end"></span>
            <span class="placeholder rounded-circle mb-3" style="width: 20px; height: 20px;"></span>
            <span class="placeholder col-11 float-end"></span>
          </p>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="pe-actions" [class.pe-actions--single]="!showBackButton">
    <button *ngIf="showBackButton" type="button" class="btn btn-outline-secondary" (click)="onBackClick()">
      <span aria-hidden="true">←</span> {{ backLabel }}
    </button>

    <button
      class="btn btn-primary"
      type="button"
      (click)="onConfirmClick()"
      [disabled]="!isReady || isConfirming || !active"
      [attr.aria-disabled]="(!isReady || isConfirming || !active) ? true : null"
      [attr.aria-busy]="isConfirming ? true : null">
      <ng-container *ngIf="!isConfirming; else btnLoading">{{ confirmLabel }}</ng-container>
      <ng-template #btnLoading>
        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        Processing...
      </ng-template>
    </button>
  </div>
</div>
